export default {
  en: {
    'components.elster-confirmation-modal.change-password': 'Change password',
    'components.elster-confirmation-modal.description':
      'When you submit this VAT information you are making a legal declaration that the information is true and complete. A false declaration can result in prosecution.',
    'components.elster-confirmation-modal-has-account.description':
      'I confirm that my client has received a copy of the information contained in this return and approved the information as being correct and complete to the best of their knowledge and belief.',
    'components.elster-confirmation-modal.address-warning':
      'This entity does not have an address associated with it. In order to continue, you need to have a valid address.',
  },
};
